import * as React from 'react';

// PACKAGES
import { useField, ErrorMessage } from 'formik';

// TYPES
interface FormGroupWithErrorTypes {
	name: string;
	className?: string;
	showError?: boolean;
	children?: React.ReactNode;
}

export const FormGroupWithError: React.FC<FormGroupWithErrorTypes> = ({
	name,
	className = '',
	showError = true,
	children
}) => {
	const [field, meta, helpers] = useField(name);

	return (
		<div className={`form-group ${className} ${meta.touched && meta.error ? 'has-error' : ''}`}>
			{children}

			{showError && <ErrorMessage name={name} component="div" className="form-validation-error" />}
		</div>
	);
};

export default FormGroupWithError;
